export var CalcState;
(function (CalcState) {
    CalcState["STATE_AVAILABLE"] = "available";
    CalcState["STATE_CALCULATING"] = "calculating";
    CalcState["STATE_CALC_SCHEDULED"] = "calc_scheduled";
    CalcState["STATE_NEEDS_REVIEW"] = "needs_review";
    CalcState["STATE_CALC_FAILED"] = "calc_failed";
})(CalcState || (CalcState = {}));
export const CALC_READY_STATES = [CalcState.STATE_AVAILABLE, CalcState.STATE_CALC_SCHEDULED];
